function isiOS() {
  if (window && window.navigator) {
    return !!navigator.userAgent.match(/(iPhone|iPad|iPod)/g);
  }
  return false;
}
function isMobile() {
  if (window && window.navigator) {
    return !!navigator.userAgent.match(/(Android|webOS|BlackBerry|Windows Phone)/g) || isiOS();
  }
  return false;
}
function isSafari() {
  if (window && window.navigator) {
    return navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1;
  }
  return false;
}
function isTablet() {
  if (window && window.navigator) {
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(navigator.userAgent);
  }
  return false;
}
function isChromeiOS() {
  if (window && window.navigator) {
    if (/CriOS/i.test(navigator.userAgent) && /iphone|ipod|ipad/i.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  }
  return false;
}

export { isiOS as a, isChromeiOS as b, isSafari as c, isTablet as d, isMobile as i };
